import mock from 'api/mockFastApi';

mock.onGet('/services/filib/iframe').reply(() => {
    return [
        200,
        'https://www.filib.fr/societe-partenaire/99692d66d799f3c0c58d698d887955c45e0f733b8f72d1a9750f50c340b67a68/424d69f325bb8df65498aa26a20e45e0/prestation/epargne-entreprise-axa'
    ];
});
